module.exports = __webpack_public_path__ + "static/media/skills.79eb0424.png";